import { DEXF_SETTINGS_SET } from '../actionConstants';
import { Action } from '../../generalTypes';
import type { IExtendedDexfSettings } from './dexfSettingsTypes';

export const setDexfSettings = (
  dexfSettingsData: IExtendedDexfSettings
): Action<IExtendedDexfSettings> => {
  return {
    type: DEXF_SETTINGS_SET,
    payload: dexfSettingsData,
  };
};
